import {postData} from "@/utils/sendData";
import {API} from "@/api/API";
import JSONAPISerializer from "jsonapi-serializer/lib/serializer";
import {deserializedData} from "@/utils/deserializedData";

export const LandingInfoMethods = {
    updateEventSlug: async (slugId, slug) => {
        let serialized = new JSONAPISerializer('event-slug', {
            keyForAttribute: 'underscore_case',
            attributes: ['slug'],
        }).serialize({
            id: slugId,
            slug: slug,
        });

        try {
            let response =  await postData(serialized, API.updateEventSlug.path(slugId), API.updateEventSlug.method)
            return deserializedData(response.data)
        } catch (err) {
            console.log(err)
        }
    },
    changeEventUrl: async (slug, eventId, type) => {
        let event = { id: eventId, type: type }
        // let serialized = new JSONAPISerializer('event-slug', {
        //     keyForAttribute: 'underscore_case',
        //     attributes: ['slug', 'event'],
        //     event: {
        //         ref: 'id',
        //     }
        // }).serialize({
        //     slug: slug,
        //     event: event
        // });

        let serialized = {
            "data": {
                "type": "event-slugs",
                "attributes": {
                    "slug": slug
                },
                "relationships": {
                    "event": {
                        "data": {
                            "type": type,
                            "id": eventId
                        }
                    }
                }
            }
        }

        try {
            let response = await postData(serialized, API.createSlug.path(), API.createSlug.method);
            return await deserializedData(response.data)
        } catch (err) {
            console.log(err)
        }
    },
    checkUrlSlug: (data, eventId) => {
        return postData(data, API.checkEventSlug.path(eventId), API.checkEventSlug.method)
    },
    generateSlug: (data) => {
        return postData(data, API.generateSlug.path(), API.generateSlug.method)
    }
}
